import classNames from "classnames";
import {
  logout,
  setCity,
  setRestaurant,
  useFetchAllCitiesQuery,
  useTypedDispatch,
  useTypedSelector,
} from "../../store";
import Button from "../common/Button";
import Dropdown from "../common/Dropdown";
import RestaurantSearchBar from "../common/SearchRestaurant";
import { Restaurant } from "../../types";
import { FaUserCircle, FaSignOutAlt, FaMapMarkerAlt, FaStore } from "react-icons/fa";

const Header = () => {
  const dispatch = useTypedDispatch();
  const { data: cities = [], isFetching } = useFetchAllCitiesQuery();
  const city = useTypedSelector((state) => state.session.city);
  const restaurant = useTypedSelector((state) => state.session.restaurant);
  const { admin } = useTypedSelector((state) => state.session);

  const handleLogout = () => dispatch(logout());

  const handleCityChange = (_field: string, cityId: string) => {
    const selectedCity = cities.find((c) => c._id === cityId);
    if (selectedCity) dispatch(setCity(selectedCity));
  };

  const handleRestaurantChange = (selectedRestaurant: Restaurant | null) => {
    dispatch(setRestaurant(selectedRestaurant));
  };

  return (
    <header className="sticky top-0 z-10 w-full bg-white border-b border-gray-200 shadow-sm px-6 py-3 flex items-center justify-between">
      {/* Left: Global Context Selectors */}
      <div className="flex items-center gap-4 flex-1 max-w-2xl">
        <div className="flex items-center gap-2 text-gray-500">
            <FaMapMarkerAlt className="text-gray-400" />
            <Dropdown
            id="city"
            // label="Ville" // Hide label for cleaner header look
            placeholder="Toutes les villes"
            options={cities.map((c) => ({ value: c._id, label: c.displayName }))}
            value={city?._id}
            isFetching={isFetching}
            className="border-none bg-gray-50 rounded-md text-sm font-medium focus:ring-0 min-w-[150px]"
            setFieldValue={handleCityChange}
            errors={{}}
            touched={{}}
            />
        </div>

        <div className="h-6 w-px bg-gray-300 mx-2" /> 

        <div className="flex items-center gap-2 flex-1 max-w-sm text-gray-500">
             <FaStore className="text-gray-400" />
            <RestaurantSearchBar
            value={restaurant}
            setRestaurant={handleRestaurantChange}
            placeholder="Filtrer par restaurant..."
            className="w-full border-none bg-gray-50 rounded-md text-sm p-2 focus:ring-2 focus:ring-primary/20"
            />
        </div>
      </div>

      {/* Right: User Profile & Actions */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-3 mr-4">
              <div className="text-right hidden md:block">
                <p className="text-sm font-semibold text-gray-800">{admin?.firstName} {admin?.lastName}</p>
                <p className="text-xs text-gray-500 capitalize">{admin?.isSuperAdmin ? 'Super Admin' : 'Admin'}</p>
              </div>
            <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                <FaUserCircle size={24} />
            </div>
        </div>
        
        <Button
          className="flex items-center gap-2 bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 hover:text-red-600 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
          onClick={handleLogout}
        >
          <FaSignOutAlt />
          <span>Déconnexion</span>
        </Button>
      </div>
    </header>
  );
};

export default Header;
